import React, { lazy, useEffect, useState, useContext, useMemo } from "react";
import moment from "moment";
import { GridComponent } from "../../components/core/Table/GridComponent";
import {
  WORK_VIEW_ITEM_TABLE_COL,
  WORK_TICKET_HISTORY_VIEW_ITEM_TABLE_COL,
  getWorkTicketHistoryViewItemExpandTableCol,
} from "../../constants/WorkViewItemTableConstants";
import { WORKTICKET_HISTORY_OVERVIEW_COL } from "../../constants/WorkTicketHistoryDetailsConstants";
import { Header } from "../../components/core/Controls";
import { Accordion, AccordionTab } from "primereact/accordion";
import styled from "styled-components";
import { WORK_VIEW_VEHICLE_TABLE_COL } from "../../constants/ViewWorkTicketConstants";
import { C4SContext } from "../../context/c4sContext";
import "./dropdown.css";
import { getFullName, getInstallType, handleChangePage, redirectToPrevPage, switchTab } from "./utils";
import _, { groupBy, orderBy, sortBy } from "lodash";
import { Loader } from "@vds/loaders";
import { Modal, ModalBody, ModalFooter } from "@vds/modals";
import Icon from "@vds/icons";
import { Title } from "@vds/typography";
import { SLNotification, FlexRow, Spacer, SmallText, CustomSLButton } from "../../components/core/utility";
import { generate } from "shortid";
import WorkTicketHistoryItemTableWTA from "./WorkTicketHistoryItemTableWTA";
import { workTicketList } from "../../services/C4S Decommission - Replacement/workTicketList";
import { getWorkTicketMaterialList } from "../../services/C4S Decommission - Replacement/getWorkTicketMaterialList";
import {
  getWorkTicketVINList,
  getWorkticketVehiclesAndAssetsList,
  getWorkticketVehiclesHistoryList,
} from "../../services/C4S Decommission - Replacement/getWorkTicketVINList";

import { Button } from "@vds/buttons";
import { hasPrivilege } from "../../../utility/privileges";
import { Privileges } from "../../../constants/PrivilegeConstants";
import { VehiclesDisplayTable } from "./VehiclesDisplayTable";
import { VehiclesHistoryTable } from "./VehiclesHistoryTable";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";
import { updateNewrelicStats } from "../../../utility/newrelic";
// Removed unused import: CustomDropdown from WorkTicketActionsModal
import WTCommonModal from "./WTCommonModal";
import UpdateAddressContactModal from "./UpdateAddressContactModal";
import { cancelWorkticket } from "../../services/C4S Decommission - Replacement/cancelWorkticket";
import { DropdownSelect } from "@vds/selects";
import { buildReturnReshipPayload, returnReship } from "../../services/C4S Decommission - Replacement/returnsHelper";
import { getOpenJobsTabIndexFromSession } from "./navigation/tabHelpers";

// Helper function to safely format dates
const formatDateSafely = (dateValue) => {
  if (!dateValue || dateValue === null || dateValue === undefined) {
    return "--";
  }

  const momentDate = moment(dateValue);
  if (!momentDate.isValid()) {
    return "--";
  }

  return momentDate.format("MMM D, yyyy");
};

export const AccordionWrapper = styled.div`
  padding-top: 2.5rem;
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header:hover .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    color: #000000;
    border: none;
    padding: 0.5rem;
    background: #f6f6f6;
    box-shadow: unset;
    border-radius: unset;
  }

  .p-accordion .p-accordion-content {
    padding: 0rem;
    border: none;
  }
  .p-accordion-header-text {
    font-weight: 700;
    font-family: Verizon-NHG-eDS;
  }
`;
const GridComponentWrapper = styled.div`
  .p-datatable-scrollable .p-datatable-wrapper {
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: block !important;
      width: 5px;
      height: 5px;
    }
    ::-webkit-scrollbar-thumb {
      display: inline-block !important;
      background-color: #c0c0c0 !important;
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1 !important;
    }
  }
`;
const TableWrapper = styled.div`
  position: relative;
  overflow-x: auto;
  width: 94%;
`;

const CustomDropdownSelect = styled.select`
  width: 180px;
  height: 32px;
  padding: 0 30px 0 10px;
  font-family: "Verizon-NHG-eTX", sans-serif;
  font-size: 14px;
  color: #000000;
  background-color: #ffffff;
  border: 1px solid #6f7171;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  line-height: 32px;

  &:disabled {
    background-color: #f6f6f6;
    color: #666b6b;
    cursor: not-allowed;
    border-color: #d8dada;
  }

  &:focus {
    outline: none;
    border-color: #000000;
    box-shadow: 0 0 0 1px #000000;
  }

  &:hover:not(:disabled) {
    border-color: #000000;
  }

  option {
    padding: 8px;
    font-size: 14px;
  }

  option:disabled {
    color: #9e9e9e;
  }
`;

export const CustomDropdown = styled(DropdownSelect)`
  & div {
    height: 32px;
    & span {
      & span {
        & div {
          & select {
            padding: 0.2rem 1rem 0.2rem 0.5rem;
            font-size: 12px;
            text-wrap: wrap;
            line-height: 0.8rem;
            &:disabled {
              -webkit-text-fill-color: #000000;
              background-color: #ffffff;
              border-bottom: 1px solid #000000;
              opacity: 0.4;
            }
          }
          & span {
            top: 0.35rem;
            right: 0.5rem;
            & svg {
              width: 0.8rem;
              height: 0.8rem;
              min-width: 0.8rem;
              min-height: 0.8rem;
            }
          }
        }
        & div {
          & div {
            & p {
              display: none;
            }
          }
        }
      }
    }
  }
`;

const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px; /* Adjust spacing between label and dropdown */
`;

export default function WorkTicketHistoryDetailedViewWTA(props) {
  const { ID, userId, renderSplitByMaterial } = props;
  const [workTicketData, setWorkTicketData] = useState([]);
  const [workTicketVehicles, setWorkTicketVehicles] = useState([]);
  const [isAsset, setIsAsset] = useState(false);
  const [workTicketHistoryData, setWorkTicketHistoryData] = useState([]);
  const [selectedTicketId, setSelectedTicketId] = useState(props.data.ticketId);
  //const { isSourceCSP } = useContext(C4SContext);
  const { isSourceCSP, source } = useContext(C4SContext);
  let cspCaseData = JSON.parse(sessionStorage.getItem("CSPDetails")),
    cspCaseOwner = "",
    crmReferenceId = "";
  let cspCaseDetails = {
    assignedTo: null,
    assignedToEmail: null,
    assignedToEid: null,
  };
  if (isSourceCSP.isSourceCSP) {
    cspCaseOwner = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.CSPOwner ?? "";
    crmReferenceId = cspCaseData.CSP?.filter((cspData) => cspData.DefaultCSP === "1")[0]?.CRM_Ref_ID ?? "";
    let cspData = cspCaseData.CSP.length ? cspCaseData.CSP.find((item) => item.DefaultCSP === "1") : {};
    cspCaseDetails = {
      assignedTo: cspData?.CSPOwner || null,
      assignedToEmail: cspData?.CSPOwnerEmail || null,
      assignedToEid: cspData?.CSPOwnerEId || null,
    };
  } else {
    cspCaseOwner = cspCaseData.CASEDetails?.filter((caseData) => caseData.DefaultCase === "1")[0]?.CaseOwner ?? "";
    crmReferenceId = cspCaseData.CASEDetails?.filter((caseData) => caseData.DefaultCase === "1")[0]?.CaseNumber ?? "";
    let caseData = cspCaseData.CASEDetails?.length ? cspCaseData.CASEDetails.find((item) => item.DefaultCase === "1") : {};
    cspCaseDetails = {
      assignedTo: caseData?.CaseOwner || null,
      assignedToEmail: caseData?.CaseOwnerEmail || null,
      assignedToEid: caseData?.CaseOwnerEId || null,
    };
  }
  let caseData = null;
  sessionStorage && sessionStorage.getItem("CSPDetails") ? JSON.parse(sessionStorage.getItem("CSPDetails")) : null;
  caseData =
    sessionStorage && sessionStorage.getItem("CSPDetails")
      ? JSON.parse(sessionStorage.getItem("CSPDetails")).CASEDetails?.filter((caseDetail) => caseDetail.DefaultCase === "1")[0] ?? ""
      : null;

  const [orderTrackingData, setOrderTrackingData] = useState();
  const [isLoading, setLoader] = useState(false);
  const [notification, setNotification] = useState(null);
  const [vehicleInfoList, setVehicleInfoList] = useState([]);
  const [vehicleHistoryList, setVehicleHistoryList] = useState({ vehicleHistory: [] });
  const [materialList, setMaterialList] = useState({ ...props.data });
  const [ticketData, setTicketData] = useState(props.data);
  const [selectedAction, setSelectedAction] = useState("");
  const [isUpdateAddressModal, setIsUpdateAddressModal] = useState(false);
  let limitWT = sessionStorage.getItem("limitWTCreation") == "true" ? true : false;
  const [isCancelOptionModal, setIsCancelOptionModal] = useState(false);
  const [commonModalStatus, setCommonModalStatus] = useState(false);
  const [return_ReshipModalStatus, setReturn_ReshipModalStatus] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [actionItem, setActionItem] = useState("");
  const [isAddressUpdateModal, setIsAddressUpdateModal] = useState(false);
  const [splitByMaterialModal, setSplitByMaterialModal] = useState(false);
  const [splitByAckSelected, setSplitByAckSelected] = useState(false);

  const TYPE_DROPDOWN = [
    { description: "Hardware accessory shipment", code: "ZHWA" },
    { description: "Mileage", code: "ZTML" },
    { description: "Customer Fee", code: "ZBTP" },
    { description: "Service-Misc", code: "ZSP1" },
    { description: "Service", code: "ZSPO" },
    { description: "Hardware shipment exchange", code: "ZZHS" },
    { description: "Hardware shipment", code: "ZHWS" },
    { description: "Hardware misc", code: "ZHS1" },
    { description: "Return Hardware", code: "ZZHR" },
    { description: "Return Accessories", code: "ZHAR" },
    { description: "Accessory Shipment Exchange", code: "ZZAE" },
  ];

  useEffect(() => {
    getWorkTicketVehicleHistory(props?.data?.ticketId);
  }, []);

  const redirectToAddJobPage = () => {
    let cspAccDetails = cspCaseData?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let data = {
      workTicket: {
        ...ticketData,
        source: source.source,
        AccountID: cspCaseData?.AccountID,
        isC4SWorkTicket: true,
        appointmentLength: 0,
        startDate: moment(new Date()).add(2, "days").format("MMMM DD,YYYY"),
        id: ID,
        userId,
        jobDetails: [
          {
            cspSfdcId: cspAccDetails?.CSPID || "",
            cspOwner: cspAccDetails?.CSPOwner || "",
            cspName: cspAccDetails?.CSPName || "",
            caseSfdcId: cspCaseData?.CASEDetails[0]?.CaseSFDCID || "",
            caseOwner: cspCaseData?.CASEDetails[0]?.CaseOwner || "",
            caseNumber: cspCaseData?.CASEDetails[0]?.CaseNumber || "",
            workTickets: [
              {
                workTicket: ticketData.ticketId,
              },
            ],
          },
        ],
      },
      cspDetails: cspCaseData,
    };
    switchTab(getOpenJobsTabIndexFromSession(), { data: data });
  };

  const handleCancelShipment = async (desc, subCode) => {
    let cspAccDetails = cspCaseData?.CSP?.filter((cspDetail) => cspDetail.DefaultCSP === "1")[0] || "";
    let salesOrgNumber = ticketData?.salesOrg.split(" ")[0];
    let payload = {
      cspId: cspAccDetails?.CSPID || "",
      workticketId: ticketData.ticketId ?? "",
      cancellationReason: desc,
      cancellationReasonCode: subCode,
      salesOrg: salesOrgNumber ?? "",
      erpTicketType: source.source === "CSP" ? "ZINS" : "ZSRQ",
      modifiedBy: `${cspCaseData?.firstName} ${cspCaseData?.lastName}`,
      modifiedByEmail: cspCaseData?.email || "",
      modifiedByEid: cspCaseData?.Employee_ID || "",
      assignedTo:
        cspCaseData?.source === "CSP"
          ? cspCaseData?.CSP.length
            ? cspCaseData?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwner
            : null
          : cspCaseData?.CASEDetails.length
          ? cspCaseData?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwner
          : null,
      assignedToEmail:
        cspCaseData?.source === "CSP"
          ? cspCaseData?.CSP.length
            ? cspCaseData?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEmail
            : null
          : cspCaseData?.CASEDetails.length
          ? cspCaseData?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEmail
          : null,
      assignedToEid:
        cspCaseData?.source === "CSP"
          ? cspCaseData?.CSP.length
            ? cspCaseData?.CSP.filter((csp) => csp?.DefaultCSP === "1")[0].CSPOwnerEId
            : null
          : cspCaseData?.CASEDetails.length
          ? cspCaseData?.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseOwnerEId
          : null,
    };
    let missingFieldsArray = [];
    for (const key of Object.keys(payload)) {
      if (key === "workticketId" || key === "salesOrg") {
        if (payload[key] === "" || payload[key] === undefined || payload[key] === null) {
          missingFieldsArray.push(key);
        }
      }
    }
    if (missingFieldsArray.length > 0) {
      setCommonModalStatus(false);
      return setTimeout(() => {
        notify(
          "Unable to cancel work ticket due to missing information. Kindly contact IT team for support. Missing information: " +
            missingFieldsArray.toString() +
            ".",
          "error",
          false
        );
      }, 10);
    }
    setLoader(true);
    let response = await cancelWorkticket(payload);

    if (response.status === 200 && response?.data?.statusCode === "200") {
      if (response?.data?.message === "Success") {
        if (response?.data?.data?.code === "200") {
          notify(response?.data?.data?.messageDescription, "success");
          getWorkTicketList();
        } else {
          notify(response?.data?.data?.messageDescription, "error");
        }
      } else {
        notify(response?.data?.data?.messageDescription, "error");
      }
      setCommonModalStatus(false);
      setTimeout(() => {
        notification.setNotification(null);
      }, 5000);
    } else {
      notify("We are currently experiencing issues, please try again", "error");
      setCommonModalStatus(false);
      setTimeout(() => {
        notification.setNotification(null);
      }, 5000);
    }
    setLoader(false);
  };

  const getActionOptions = () => {
    const status = ticketData?.status?.toLowerCase();
    const hasEsnToBeReturned = ticketData?.hasEsnToBeReturned;
    const allowCancel = ticketData?.allowCancel;
    const options = [];

    if (status === "error") {
      options.push({ label: "Cancel Ticket", value: "Cancel" });
    }

    if ((status === "released" || status === "backordered" || status === "submitted" || status === "created") && allowCancel) {
      options.push({ label: "Cancel Work Ticket", value: "CancelShipment" });
    }

    // Add Update Address option for specific statuses
    if (status === "submitted" || status === "backordered" || status === "created") {
      options.push({ label: "Update Address/POC", value: "Update" });
    }

    if (status === "backordered") {
      options.push({ label: "Split by Material", value: "Split" });
    }

    if ((status === "shipped" || status === "delivered") && hasEsnToBeReturned !== "true") {
      options.push({ label: "Return/Reship", value: "Return_Reship" });
    }
    if ((status === "shipped" || status === "delivered") && hasEsnToBeReturned !== "true") {
      options.push({ label: "Return Only After Cancellation", value: "ReturnOnly" });
    }

    if ((status === "shipped" || status === "delivered") && hasEsnToBeReturned !== "true") {
      options.push({ label: "Reship Only", value: "ReshipOnly" });
    }

    return options;
  };

  const handleActionChange = (actionValue) => {
    const action = actionValue || selectedAction;
    if (!action) return;

    setSelectedAction("");

    switch (action) {
      case "Schedule":
        redirectToAddJobPage();
        break;

      case "Cancel":
        setIsCancelOptionModal(true);
        break;

      case "CancelShipment":
        setCommonModalStatus(true);
        setTitle("Cancel Work Ticket");
        setSubTitle("Select Reason");
        setActionItem("CancelShipment");
        break;

      case "Split":
        setSplitByMaterialModal(true);
        break;

      case "Return_Reship":
        setCommonModalStatus(true);
        setTitle("Return/Reship Reason");
        setSubTitle("Select Reason");
        if (ticketData?.status?.toLowerCase() === "shipped") {
          setActionItem("ReturnReshipShipped");
        } else if (ticketData?.status?.toLowerCase() === "delivered") {
          setActionItem("ReturnReshipDelivered");
        }
        break;

      case "ReshipOnly":
        setCommonModalStatus(true);
        setTitle("Return/Reship Reason");
        setSubTitle("Select Reason");
        if (ticketData?.status?.toLowerCase() === "shipped") {
          setActionItem("ReshipOnlyShipped");
        } else if (ticketData?.status?.toLowerCase() === "delivered") {
          setActionItem("ReshipOnlyDelivered");
        }
        break;

      case "ReturnOnly":
        handleReturnOnlyDirect();
        break;

      // Open Update Address modal similar to ThreeDotsTemplateWTA
      case "Update":
        setIsAddressUpdateModal(true);
        break;

      default:
        break;
    }
  };

  const handleReturnOnlyDirect = async () => {
    setLoader(true);
    let cspCaseData = JSON.parse(sessionStorage.getItem("CSPDetails"));
    // Use full cspCaseData for building payload (caseData here may be undefined in certain contexts)
    const returnPayload = buildReturnReshipPayload({
      ticketDetails: ticketData,
      cspDetails: cspCaseData,
      action: "Return",
      returnReason: "",
      returnSubReason: "",
    });
    const response = await returnReship(returnPayload);
    setLoader(false);

    if (response.status === 200 && response?.data?.statusCode === "200") {
      if (response?.data?.message === "Success") {
        notify(response?.data?.data?.messageDescription, "success");
        setTimeout(() => {
          switchTab(1, { isFromWorkTicketHistory: true });
        }, 2000);
      } else {
        notify(response?.data?.data?.messageDescription || "Failed to process Return Only request", "error");
      }
    } else {
      notify("We are currently experiencing issues, please try again", "error");
    }
  };

  const handleShipmentDamagedModal = () => {
    // Logic for handling shipment damaged modal
    setTitle("Who Damaged the Package?");
    setSubTitle("Select Who Damaged the Package");
    setActionItem("DamagedPackage");
    setCommonModalStatus(true);
  };

  const handleLostShipmentModal = () => {
    // Logic for handling lost shipment modal
    setTitle("Who Lost the Package?");
    setSubTitle("Select Who Lost the Package");
    setActionItem("LostPackage");
    setCommonModalStatus(true);
  };

  const getWorkTicketList = async (selectedWorkTicketId) => {
    let cspAccountDetails = null;
    cspAccountDetails = sessionStorage && sessionStorage.getItem("CSPDetails") ? JSON.parse(sessionStorage.getItem("CSPDetails")) : null;
    if (cspAccountDetails === null) return false;
    updateNewrelicStats();
    setLoader(true);
    let payLoad = {
      accountId: props?.AccountID,
      cspId:
        isSourceCSP.isSourceCSP && cspAccountDetails?.CSP?.length
          ? cspAccountDetails.CSP.filter((csp) => csp.DefaultCSP === "1")[0].CSPID || null
          : null,
      caseId:
        !isSourceCSP.isSourceCSP && cspAccountDetails?.CASEDetails?.length
          ? cspAccountDetails.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseSFDCID || null
          : null,
    };
    let response = await workTicketList(payLoad);
    if (response.status === 200) {
      let responseWithCityState = response.data.data.map((data) => {
        data.installType = getInstallType(data.installType);
        data.cityState = `${data.city}, ${data.stateCode}`;
        return data;
      });
      let sortedResponse = orderBy(
        responseWithCityState,
        [
          function (o) {
            return new Date(o.modifiedAt);
          },
          function (o) {
            return new Date(o.createdAt);
          },
          "installType",
          "cityState",
        ],
        ["desc", "desc"]
      );
      if (!isSourceCSP.isSourceCSP) {
        let currentCase = groupBy(responseWithCityState, { caseNumber: caseData.CaseNumber }).true ?? [];
        let otherCase = groupBy(responseWithCityState, { caseNumber: caseData.CaseNumber }).false ?? [];
        currentCase = orderBy(
          currentCase,
          function (o) {
            return new Date(o.modifiedAt);
          },
          "desc"
        );
        otherCase = orderBy(
          otherCase,
          function (o) {
            return new Date(o.modifiedAt);
          },
          "desc"
        );
        sortedResponse = [...currentCase, ...otherCase];
      }
      sortedResponse = sortedResponse.map((data) => {
        return {
          caseNumber: data.caseNumber,
          ticketId: data.workticketId,
          workticketType: data.workticketType,
          // Added explicit return reason fields for RETURN work tickets
          returnReason: data.returnReason || data.returnReshipReason || data.returnOnlyReason || null,
          returnSubReason: data.returnSubReason || data.returnReshipSubReason || data.returnOnlySubReason || null,
          migratedRecord: data.workticketId?.length && data.workticketId[0] === "W" ? false : true,
          workOrderOwner: data.workOrderOwner,
          installType: data.installType,
          cityState: `${data.city}, ${data.stateCode}`,
          status: data.wtStatus,
          allowCancel: data.allowCancel,
          cancellationReason: data.cancellationReason,
          requestDate: data.requestDate,
          erpTicketType: data.erpTicketType,
          addressOne: data.addressOne,
          addressTwo: data.addressTwo,
          city: data.city,
          stateCode: data.stateCode,
          country: data.country,
          zipCode: data.zipCode,
          workTicket: data.workticketId,
          contactName: data.contactName || "",
          phone: data.phoneNumber || "",
          email: data.emailAddress || "",
          division: data?.division || null,
          distributionChannel: data?.distChannel || null,
          salesOrg: data.salesOrg,
          salesOrderId: data.salesOrderId || "",
          // pgiDate: data.erpData[0].shipmentDate,
          contractAccount: data.contractAccount,
          assignedTo: data.assignTo,
          crmReferenceId: isSourceCSP.isSourceCSP
            ? cspAccountDetails?.CSP?.length
              ? cspAccountDetails.CSP[0].CRM_Ref_ID
              : null
            : cspAccountDetails?.CASEDetails?.length
            ? cspAccountDetails.CASEDetails[0].CaseNumber
            : null,
          currencyCode: data.currencyCode,
          erpPartnerNumber: cspAccountDetails?.ERP_Partner_Number ?? null,
          erpPrimaryContactNumber: cspAccountDetails?.ERP_Primary_Contact_NUmber ?? null,
          accountName: cspAccountDetails?.AccountName ?? null,
          cspCustomerPONumber: cspAccountDetails?.CSP_CUstomer_PO_Number ?? null,
          subStatus: data.subStatus,
          erpStatus: data.erpStatus,
          wareHouseNotes: data.wareHouseNotes,
          esnNotes: data.esnNotes,
          erpMigrationData: {
            x1ErpSalesRepId: data.x1ErpSalesRepId,
            xcontactMobile: data.xcontactMobile,
            xc4sObjectId: data.xc4sObjectId,
            xschedulingNotes: data.xschedulingNotes,
            xvendorMessage: data.xvendorMessage,
            xnotesToTechnician: data.xnotesToTechnician,
            xfieldNotes: data.xfieldNotes,
            xrequestStartDateTime: data.xrequestStartDateTime,
            xrequestEndDateTime: data.xrequestEndDateTime,
            xvendorId: data.xvendorId,
          },
          ownerName: data.assignedTo,
          assignedToEid: data.assignedToEid,
          assignedToEmail: data.assignedToEmail,
          createdBy: data.createdBy,
          createdByEid: data.createdByEid,
          createdByEmail: data.createdByEmail,
          createdOn: data.createdAt,
          modifiedAt: data?.modifiedAt ? moment(data.modifiedAt).format("MM/DD/YYYY") : null,
          modifiedBy: data.modifiedBy,
          modifiedByEid: data.modifiedByEid,
          modifiedByEmail: data.modifiedByEmail,
          ticketType: data.ticketType,
        };
      });
      // Filter for selectedWorkTicketId
      const filteredResponse = sortedResponse.filter((data) => data.ticketId === selectedWorkTicketId);
      setWorkTicketHistoryData(filteredResponse.length > 0 ? filteredResponse : []);
    } else {
      notify("We are currently experiencing issues, please try again", "error");
    }
    setLoader(false);
  };

  // useEffect(() => {
  //   setTicketData(props.data);
  //   getWorkTicketMateriallist(props?.data?.ticketId);
  // }, [props.data]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (selectedTicketId === props?.data?.ticketId) {
      setTicketData(props.data);
      getWorkTicketMateriallist(props?.data?.ticketId);
    } else {
      const returnData = workTicketHistoryData.find((item) => item.ticketId === selectedTicketId);
      setTicketData(returnData || {});
      getWorkTicketMateriallist(selectedTicketId);
    }
  }, [selectedTicketId, workTicketHistoryData, props.data]);

  const workTicketHistoryOverviewRows = useMemo(
    () => [
      {
        ticketType: ticketData?.erpTicketType || "--",
        status: ticketData?.status || "--",
        createdOn: ticketData?.createdOn ? moment(ticketData.createdOn).format("MMM D, yyyy") : "--",
        changedOn: ticketData?.modifiedAt ? moment(ticketData.modifiedAt).format("MMM D, yyyy") : "--",
        modifiedAt: ticketData?.modifiedAt ? moment(ticketData.modifiedAt).format("MMM D, yyyy") : "--",
        modifiedBy: ticketData?.modifiedBy || "--",
        createdBy: ticketData?.createdBy || "--",
        distributionChannel: ticketData?.distributionChannel || "--",
        returnReason: ticketData?.returnReason || "--",
        returnSubReason: ticketData?.returnSubReason || "--",
        requestDate: ticketData?.requestDate ? moment(ticketData.requestDate).format("MMM D, yyyy") : "--",
        ownerName: ticketData?.ownerName || "--",
        statusDate: ticketData?.statusDate ? moment(ticketData.statusDate).format("MMM D, yyyy") : "--",
        contractAccount: ticketData?.contractAccount ?? "--",
        salesOrg: ticketData?.salesOrg || "--",
        division: ticketData?.division || "--",
        crmReferenceId: ticketData?.crmReferenceId || "--",
        salesOrderId: ticketData?.salesOrderId || "--",
      },
    ],
    [ticketData]
  );

  const onHyperLinkClick = async (data, column) => {
    if (column === "Return" && data.return) {
      await getWorkTicketList(data.return);
      // Set selectedTicketId after workTicketHistoryData is updated
      setTimeout(() => {
        setSelectedTicketId(data.return);
      }, 0);
      // Do not set ticketData directly here; let useEffect handle it after selectedTicketId changes
      await getWorkTicketMateriallist(data.return);
    } else if (column === "Reference Work Ticket" && data.referenceWt) {
      await getWorkTicketList(data.referenceWt);
      // Set selectedTicketId after workTicketHistoryData is updated
      setTimeout(() => {
        setSelectedTicketId(data.referenceWt);
      }, 0);
      // Do not set ticketData directly here; let useEffect handle it after selectedTicketId changes
      await getWorkTicketMateriallist(data.referenceWt);
    }
  };

  const rowExpansionTemplate = (data) => {
    // Check if data has existing bundles structure
    const transformedBundles = [];

    // Validate that data exists
    if (data) {
      // First, check if data has existing bundles
      if (Array.isArray(data.bundles) && data.bundles.length > 0) {
        transformedBundles.push(...data.bundles);
      }
      if (data.esnDetailsList && data.esnDetailsList.length > 0) {
        // Group by bundleId first
        const groupedByBundle = data.esnDetailsList.reduce((acc, esnDetail) => {
          const bundleId = esnDetail.bundleId || "";
          if (!acc[bundleId]) {
            acc[bundleId] = [];
          }
          acc[bundleId].push(esnDetail);
          return acc;
        }, {});

        // Process each bundle group
        Object.entries(groupedByBundle).forEach(([bundleId, bundleEsns]) => {
          // Group by techRefId within each bundle
          const groupedByTechRef = bundleEsns.reduce((acc, esnDetail) => {
            const techRefId = esnDetail.techRefId || "";
            if (!acc[techRefId]) {
              acc[techRefId] = [];
            }
            acc[techRefId].push(esnDetail);
            return acc;
          }, {});

          // Create summary lines for each techRefId group
          const summaryLines = Object.entries(groupedByTechRef).map(([techRefId, techEsns]) => {
            const esnDetails = techEsns.map((esnDetail) => ({
              esn: String(esnDetail.esn || "--"),
              esnState: esnDetail?.esnState ? (String(esnDetail?.esnState).trim() === "-" ? "--" : String(esnDetail?.esnState)) : "--",
              trackingNumber: String(esnDetail.trackingNum || "--"),
              trackingStatus: String(esnDetail.trackingStatus || "--"),
              deliveryDate: formatDateSafely(esnDetail.deliveryDate),
              deliveryNumber: String(esnDetail.deliveryNum || "--"),
              returnWt: ticketData?.workticketType?.toLowerCase() === "outbound" ? String(esnDetail.referenceWt || "--") : "--",
              referenceWt: String(esnDetail.referenceWt || "--"),
              referenceWtStatus: ticketData?.workticketType?.toLowerCase() === "outbound" ? String(esnDetail.referenceWtStatus || "--") : "--",
              referenceWtStatusDate:
                ticketData?.workticketType?.toLowerCase() === "outbound" ? formatDateSafely(esnDetail.referenceWtStatusDate || "--") : "--",
              unExpected: String(esnDetail.unexpected || "--"),
            }));

            return {
              subscription: techEsns[0]?.subscriptionName || "subscription name",
              techRefId: techRefId,
              esnDetails: esnDetails,
            };
          });

          transformedBundles.push({
            bundleId: bundleId,
            summaryLines: summaryLines,
          });
        });
      }
      // Check if data.esns exists and process individual ESN objects
      else if (data.esns && Array.isArray(data.esns) && data.esns.length > 0) {
        // ...existing code...
      }
    }

    // Use the transformed bundles or empty array if no data
    let allBundles = transformedBundles.length > 0 ? transformedBundles : [];

    let gridRows = [];

    // Process the bundles (either transformed or existing)
    allBundles.forEach((bundle) => {
      if (Array.isArray(bundle.summaryLines)) {
        // Group summaryLines by subscription+techRefId
        const groups = {};
        bundle.summaryLines.forEach((summary) => {
          const key = `${summary.subscription || ""}|${summary.techRefId || ""}`;
          if (!groups[key]) groups[key] = [];
          groups[key].push(summary);
        });

        Object.values(groups).forEach((summaries) => {
          // Flatten all esnDetails in this group
          let esnRows = [];
          summaries.forEach((summary) => {
            if (Array.isArray(summary.esnDetails) && summary.esnDetails.length > 0) {
              summary.esnDetails.forEach((esn) => {
                esnRows.push({
                  bundleId: bundle.bundleId,
                  subscription: summary.subscription,
                  techRefId: summary.techRefId,
                  referenceWt: esn?.referenceWt,
                  esn: esn.esn,
                  esnState: esn.esnState,
                  trackingNumber: esn.trackingNumber,
                  trackingStatus: esn.trackingStatus,
                  deliveryDate: formatDateSafely(esn.deliveryDate),
                  deliveryNumber: esn.deliveryNumber,
                  return: ticketData?.workticketType?.toLowerCase() === "outbound" ? String(esn.referenceWt || "--") : "--",
                  referenceWtStatus: ticketData?.workticketType?.toLowerCase() === "outbound" ? String(esn.referenceWtStatus || "--") : "--",
                  referenceWtStatusDate:
                    ticketData?.workticketType?.toLowerCase() === "outbound" ? formatDateSafely(esn.referenceWtStatusDate || "--") : "--",
                  unexpected: esn.unExpected,
                });
              });
            } else {
              esnRows.push({
                bundleId: bundle.bundleId,
                subscription: summary.subscription,
                techRefId: summary.techRefId,
                referenceWt: summary?.referenceWt || "",
                esn: "",
                esnState: "",
                trackingNumber: "",
                trackingStatus: "",
                deliveryDate: "",
                deliveryNumber: "",
                return: "",
                referenceWtStatus: "",
                referenceWtStatusDate: "",
                unexpected: "",
              });
            }
          });

          // Show bundleId, subscription, techRefId only in first row of group, blank for repeated rows if more than 1 row
          esnRows.forEach((row, idx) => {
            gridRows.push({
              ...row,
              bundleId: esnRows.length > 1 ? (idx === 0 ? row.bundleId : "") : row.bundleId,
              subscription: esnRows.length > 1 ? (idx === 0 ? row.subscription : "") : row.subscription,
              techRefId: esnRows.length > 1 ? (idx === 0 ? row.techRefId : "") : row.techRefId,
            });
          });
        });
      }
    });
    const WORK_TICKET_HISTORY_VIEW_ITEM_EXPAND_TABLE_FILTERED_COL = getWorkTicketHistoryViewItemExpandTableCol(ticketData?.workticketType);
    return (
      <GridComponent
        isExportEnabled={false}
        enableFullWidth={true}
        noDataMessage="No data available to display"
        rows={gridRows}
        hideGlobalFilter={true}
        columns={WORK_TICKET_HISTORY_VIEW_ITEM_EXPAND_TABLE_FILTERED_COL}
        paginator={false}
        whiteSpace="normal"
        hyperLinkClicked={onHyperLinkClick}
        headerStyle={{
          fontWeight: 700,
          fontSize: "12px",
          lineHeight: "16px",
          letterSpacing: "0px",
          fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
          marginBottom: "4px",
          color: "#000000",
        }}
        rowStyle={{
          fontWeight: 400,
          fontSize: "12px",
          lineHeight: "16px",
          letterSpacing: "0px",
          fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
          marginBottom: "4px",
          color: "#000000",
        }}
      />
    );
  };

  useEffect(() => {
    let orderTrackingInfo = {
      plannedQuantity: [1],
      pgiDate: [1],
      selfInstalled: [0],
      installed: [1],
      returnedOrder: [1],
    };
    setOrderTrackingData(orderTrackingInfo);
  }, []);

  const getWorkTicketMateriallist = async (selectedTicketId = "", isRefresh = false) => {
    setLoader(true);
    let workTicketId = selectedTicketId || props.data.ticketId;
    let response = await getWorkTicketMaterialList(workTicketId);
    if (response?.status === 200 && response?.data) {
      response = response.data.data;
      let currentTicketData = workTicketHistoryData[0] || props.data;
      setMaterialList({ ...currentTicketData, materials: response });
      let workTicketListData = response?.map((material) => {
        return {
          id: material.id || "",
          MMID: material.materialId,
          itemDescription: material.materialName,
          category: material.category,
          subCategory: material.subCategory,
          categorySubcategory: material.category + " - " + material.subCategory,
          atpQuantity: material.atpQuantity,
          atpDate: material.atpDate ? moment(material.atpDate).format("MMM D, yyyy") : "",
          lineId: material.materialLineId,
          deliveryBlockDescription: material.deliveryBlockDescription,
          soRejected: material.soRejected,
          type: material.processingCode,
          displayType: getFullName(TYPE_DROPDOWN, material.processingCode),
          contractItem: material.contractName,
          quantity: material.totalQty,
          MmidPgiDate: material.materialId + " - " + props?.data?.pgiDate,
          esns: material.esn,
          trackingNumbers: material.trackingNumbers,
          trackingUrls: material.trackingUrls,
          deliveryBlock: material.deliveryBlock,
          carriers: material.carriers,
          pgiDate: formatDateSafely(material.pgiDate),
          pgiQty: material.pgiQty,
          salesOrder: material.salesOrder,
          x_purchaseOrder: material.x_purchaseOrder,
          deliveryDocNumber: material.deliveryDocNumber,
          wtMaterialId: material.mid,
          contractId: material.cid,
          sapId: material.sapId,
          referenceWt: material.referenceWt,
          techRefId: material.techRefId,
          bundleId: material.bundleId,
          defaultReturnType: material.defaultReturnType,
          customerMaterialCharge: material.customerMaterialCharge,
          materialChargeCurrency: material.materialChargeCurrency,
          totalQty: material.totalQty,
          orderType: material.orderType,
          contractOverride: material.contractOverride,
          bundles: material.bundles || [],
          esnDetailsList: material.esnDetailsList,
          erpType: material.processingCode,
        };
      });
      setWorkTicketData(workTicketListData);
      isRefresh ? setLoader(false) : getWorkTicketVINlist(workTicketId);
    } else {
      setMaterialList((prev) => ({ ...prev, materials: [] }));
      notify("Unable to fetch material list due to an unexpected error", "error");
      isRefresh ? setLoader(false) : getWorkTicketVINlist();
    }
  };

  const getWorkTicketVINlist = async (selWorkTicketId = "") => {
    setLoader(true);
    let workTicketId = selWorkTicketId || props?.data?.ticketId;
    let response = cspCaseData?.CSP?.[0]?.isWTA ? await getWorkticketVehiclesAndAssetsList(workTicketId) : await getWorkTicketVINList(workTicketId);
    if (response?.status === 200 && response?.data) {
      const payload = response?.data?.data;
      const assets = Array.isArray(payload?.assets) ? payload.assets : [];
      const vehicles = Array.isArray(payload?.vehicles) ? payload.vehicles : [];
      const isAssetsOnly = assets.length > 0 && vehicles.length === 0 ? true : false;
      setIsAsset(isAssetsOnly);

      if (cspCaseData?.CSP?.[0]?.isWTA) {
        response = response.data.data.vehicles.concat(response.data.data.assets);
      } else response = response.data.data;
      setVehicleInfoList(response);
      setMaterialList((prev) => ({ ...prev, vins: response }));
      let vins =
        response?.length > 0
          ? response?.filter((item) => item.vin || (item.year && item.make && item.model)).map((item, index) => ({ ...item, index: index + 1 }))
          : [];
      setWorkTicketVehicles(vins);
      setLoader(false);
    } else {
      setMaterialList((prev) => ({ ...prev, vins: [] }));
      notify("Unable to fetch VIN list due to an unexpected error", "error");
      setLoader(false);
    }
  };

  const getWorkTicketVehicleHistory = async (workTicketId) => {
    let response = await getWorkticketVehiclesHistoryList(workTicketId);
    if (response?.status === 200 && response?.data?.data) {
      setVehicleHistoryList(response.data.data);
    } else {
      notify("Unable to fetch Vehicle History list due to an unexpected error", "error");
    }
  };

  const notify = (content, type) => {
    setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} />);
  };

  const handleCancelWorkTicket = async () => {
    const payload = {
      workticketId: selectedTicketId || ticketData?.ticketId,
      modifiedBy: "User Name",
      modifiedByEmail: "user@example.com",
    };
    try {
      const response = await cancelWorkticket(payload);
      if (response.status === 200 && response.data.statusCode === "200") {
        setIsCancelOptionModal(false);
        notify("Ticket has been canceled successfully!", "success");
      } else {
        notify("Failed to cancel the ticket. Please try again.", "error");
      }
    } catch (error) {
      notify("An error occurred while canceling the ticket.", "error");
    }
  };

  return (
    <>
      <Loader active={isLoading} fullscreen />
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "400",
              color: "black",
            }}
            onClick={() => {
              handleChangePage({ index: 0 });
              //messageBus.trigger("closeAccordions");
            }}
          >
            {"Work Ticket History"}
          </span>
        </BreadcrumbItem>
        <BreadcrumbItem key={1} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
          >
            {ticketData?.ticketId}
          </span>
        </BreadcrumbItem>
      </Breadcrumbs>
      <Header>
        <FlexRow style={{ justifyContent: "space-between", alignItems: "center" }} onClick={(event) => event.preventDefault()}>
          <span
            style={{
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "28px",
              letterSpacing: "0px",
              fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
              marginBottom: "8px",
              color: "#000000",
            }}
          >
            {ticketData?.ticketId} {ticketData?.workticketType ? " - " + ticketData?.workticketType : ""}
          </span>
          {props?.data?.workticketType === "Outbound" && (
            <div style={{ marginLeft: "auto", display: "flex", gap: "10px", alignItems: "center" }}>
              <CustomDropdownSelect
                value={selectedAction}
                onChange={(e) => {
                  setSelectedAction(e.target.value);
                  if (e.target.value) handleActionChange(e.target.value);
                }}
                disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY) || getActionOptions().length === 0}
              >
                <option value="" disabled>
                  Select Action
                </option>
                {getActionOptions().map((option) => {
                  const statusLc = String(ticketData?.status || "").toLowerCase();
                  const scheduleCond =
                    option.value === "Schedule" &&
                    ticketData?.installType === "VMI" &&
                    ticketData?.hasEsnToBeReturned !== "true" &&
                    (statusLc === "released" ||
                      statusLc === "shipped" ||
                      statusLc === "backordered" ||
                      statusLc === "created" ||
                      statusLc === "submitted" ||
                      statusLc === "packaging" ||
                      statusLc === "delivered");
                  const optionDisabled = option.value === "Schedule" ? (scheduleCond ? false : true) : false;
                  return (
                    <option value={option.value} key={option.value} disabled={optionDisabled}>
                      {option.label}
                    </option>
                  );
                })}
              </CustomDropdownSelect>
              <Button
                size="small"
                secondary
                aria-label="Refresh"
                role="button"
                aria-disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                onClick={() => {
                  getWorkTicketMateriallist(false);
                }}
              >
                Refresh
              </Button>
            </div>
          )}
          {props?.data?.workticketType !== "Outbound" && (
            <div style={{ display: "flex", gap: "8px", marginLeft: "auto" }}>
              <Button
                size="small"
                secondary
                aria-label="Refresh"
                role="button"
                aria-disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                disabled={limitWT || hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY)}
                css={{ marginTop: "5px" }}
                onClick={() => {
                  getWorkTicketMateriallist(false);
                }}
              >
                Refresh
              </Button>
            </div>
          )}
        </FlexRow>
      </Header>

      {notification}
      <TableWrapper>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "24px", marginTop: "10px", marginLeft: "3px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: "16px" }}>
            {WORKTICKET_HISTORY_OVERVIEW_COL.slice(0, 7).map((col) => (
              <div key={col.value} style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                    marginBottom: "4px",
                    color: "#1E1E1E",
                  }}
                >
                  {col.key}
                </div>
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                    marginBottom: "4px",
                    color: "#1E1E1E",
                  }}
                >
                  {workTicketHistoryOverviewRows[0][col.value]}
                </div>
              </div>
            ))}
            {/* Conditionally render referenceTicket column if status is "Released" */}
            {ticketData?.workticketType && ["return"].includes(String(ticketData?.workticketType).toLowerCase()) && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                    marginBottom: "4px",
                    color: "#1E1E1E",
                  }}
                >
                  {WORKTICKET_HISTORY_OVERVIEW_COL.find((col) => col.value === "returnReason")?.key || "Return Reason"}
                </div>
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                    marginBottom: "4px",
                    color: "#1E1E1E",
                  }}
                >
                  {workTicketHistoryOverviewRows[0].returnReason}
                </div>
              </div>
            )}
            <div />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: "16px" }}>
            {WORKTICKET_HISTORY_OVERVIEW_COL.slice(8, 16).map((col) => (
              <div key={col.value} style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                    marginBottom: "4px",
                    color: "#1E1E1E",
                  }}
                >
                  {col.key}
                </div>
                <div
                  style={{
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0px",
                    fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                    marginBottom: "4px",
                    color: "#1E1E1E",
                  }}
                >
                  {workTicketHistoryOverviewRows[0][col.value]}
                </div>
              </div>
            ))}
          </div>
        </div>
      </TableWrapper>
      <AccordionWrapper>
        <Accordion activeIndex={0} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          <AccordionTab header="Items">
            <GridComponentWrapper>
              <GridComponent
                isExportEnabled={false}
                noDataMessage="No data available to display"
                rows={workTicketData}
                hideGlobalFilter={true}
                columns={cspCaseData?.CSP?.[0]?.isWTA ? WORK_TICKET_HISTORY_VIEW_ITEM_TABLE_COL : WORK_VIEW_ITEM_TABLE_COL}
                paginator={false}
                whiteSpace="normal"
                rowExpansionPosition="beginning"
                rowExpansionTemplate={rowExpansionTemplate}
                expandableRows={true}
                expandIcon={true}
                headerStyle={{
                  fontWeight: 700,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0px",
                  fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                  marginBottom: "4px",
                  color: "#000000",
                }}
                rowStyle={{
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0px",
                  fontFamily: "Verizon NHG eTX, Helvetica, Arial, sans-serif",
                  marginBottom: "4px",
                  color: "#000000",
                }}
              />
            </GridComponentWrapper>
          </AccordionTab>
        </Accordion>
      </AccordionWrapper>
      {/* {!isSourceCSP.isSourceCSP && ( VZC42148-1817
        <AccordionWrapper>
          <Accordion role="region" activeIndex={0} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
            <AccordionTab aria-label="Order Tracking" header="Order Tracking">
              <OrderTrackingInfoTable data={orderTrackingData} />
            </AccordionTab>
          </Accordion>
        </AccordionWrapper>
      )} */}
      <AccordionWrapper>
        <Accordion role="region" activeIndex={5} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          <AccordionTab aria-label="Vehicles and Assets" header="Vehicles and Assets">
            <div tabIndex={0} aria-label="vehicle list table">
              {cspCaseData.CSP?.[0]?.isWTA ? (
                <VehiclesDisplayTable data={workTicketVehicles} isAsset={isAsset} />
              ) : (
                <GridComponent
                  isExportEnabled={false}
                  noDataMessage="No data available to display"
                  rows={workTicketVehicles}
                  hideGlobalFilter={true}
                  columns={WORK_VIEW_VEHICLE_TABLE_COL}
                  paginator={false}
                />
              )}
            </div>
          </AccordionTab>
        </Accordion>
      </AccordionWrapper>
      <WorkTicketHistoryItemTableWTA
        data={materialList}
        AccountID={props?.AccountID}
        ID={props?.ID}
        userId={props?.userId}
        setNotification={setNotification}
      />
      <AccordionWrapper>
        <Accordion role="region" activeIndex={5} expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
          <AccordionTab aria-label="Vehicle History Log" header="Vehicle History Log">
            <div tabIndex={0} aria-label="vehicle history table">
              <VehiclesHistoryTable data={vehicleHistoryList.vehicleHistory} />
            </div>
          </AccordionTab>
        </Accordion>
      </AccordionWrapper>
      <Spacer top="3rem" />
      {commonModalStatus && (
        <WTCommonModal
          commonModalStatus={commonModalStatus}
          setCommonModalStatus={setCommonModalStatus}
          handleCancelShipment={handleCancelShipment}
          handleShipmentDamagedModal={handleShipmentDamagedModal}
          handleLostShipmentModal={handleLostShipmentModal}
          title={title}
          subTitle={subTitle}
          actionItem={actionItem}
          notify={notify}
          ticketDetails={ticketData}
        />
      )}
      {isCancelOptionModal && (
        <Modal
          role="dialog"
          ariaLabel="Cancel Ticket"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ paddingLeft: "0.7rem" }}>
                <Title size="medium">Cancel Ticket</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setIsCancelOptionModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody css={{ padding: "16px 0 16px 16px !important" }}>
            <p style={{ fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif", fontSize: "14px" }}>
              Are you sure to cancel the workticket - {selectedTicketId || ticketData?.ticketId}?
            </p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <FlexRow>
              <CustomSLButton aria-label="Yes" role="button" css={{ padding: "0 10px 0 10px" }} primary onClick={handleCancelWorkTicket}>
                Yes
              </CustomSLButton>
              <CustomSLButton aria-label="No" role="button" secondary onClick={() => setIsCancelOptionModal(false)}>
                No
              </CustomSLButton>
            </FlexRow>
          </ModalBody>
        </Modal>
      )}
      {isAddressUpdateModal && (
        <UpdateAddressContactModal
          isAddressUpdateModal={isAddressUpdateModal}
          setIsAddressUpdateModal={setIsAddressUpdateModal}
          notify={notify}
          ticketDetails={ticketData}
        />
      )}
      {return_ReshipModalStatus && isCancelOptionModal && (
        <Modal
          role="dialog"
          ariaLabel="Return Reship Modal"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ paddingLeft: "0.7rem" }}>
                <Title size="medium">{title}</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setIsCancelOptionModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody css={{ padding: "16px 0 16px 16px !important" }}>
            <p style={{ "font-family": "Verizon-NHG-eTX" }}>You are about to process a return and reship for this work ticket.</p>
            <p style={{ "font-family": "Verizon-NHG-eTX" }}>Are you sure you want to continue?</p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <FlexRow>
              <CustomSLButton aria-label="No" role="button" secondary onClick={() => setIsCancelOptionModal(false)}>
                Cancel
              </CustomSLButton>
              <CustomSLButton aria-label="Yes" role="button" css={{ padding: "0 10px 0 10px" }} primary onClick={handleCancelWorkTicket}>
                Continue
              </CustomSLButton>
            </FlexRow>
          </ModalBody>
        </Modal>
      )}
      {splitByMaterialModal && (
        <Modal
          role="dialog"
          ariaLabel="Split by Material"
          opened={true}
          disableOutsideClick
          closeButton={
            <FlexRow justifyContent="space-between" onClick={(event) => event.preventDefault()}>
              <div css={{ fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif", paddingLeft: "0.7rem" }}>
                <Title size="medium">Split by Material</Title>
              </div>
              <div style={{ marginRight: "1.3rem" }}>
                <div style={{ cursor: "pointer" }} onClick={() => setSplitByMaterialModal(false)}>
                  <Icon
                    aria-label="close"
                    alt="close-icon"
                    role="img"
                    name="close"
                    size="medium"
                    color="#000000"
                    style={{ cursor: "pointer", outline: "none" }}
                  />
                </div>
              </div>
            </FlexRow>
          }
        >
          <ModalBody>
            <p style={{ fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif" }}>
              Splitting by material is against standard business practices and should only happen in rare cases with manager approval. Please only
              move forward if you gained approval from a deployment leader.
            </p>
            <Spacer top="1rem" />
            <Spacer bottom="10px" />
            <div>
              <input
                id="split-by-ack-checkbox"
                selected={splitByAckSelected}
                type="checkbox"
                name="default"
                style={{ width: "20px", height: "20px" }}
                onChange={() => {
                  setSplitByAckSelected(!splitByAckSelected);
                }}
              />
              <label
                htmlFor="split-by-ack-checkbox"
                style={{
                  fontSize: "16px",
                  fontWeight: 700,
                  top: "-4px",
                  position: "relative",
                  display: "inline-block",
                  paddingLeft: "6px",
                  fontFamily: "Verizon-NHG-eDS, Helvetica, Arial, sans-serif",
                }}
              >
                Acknowledgement
              </label>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: 400,
                  paddingLeft: "25px",
                  color: "black",
                  fontFamily: "Verizon-NHG-eTX, Helvetica, Arial, sans-serif",
                  marginTop: "4px",
                }}
              >
                By moving forward with splitting, you are acknowledging that this is approved by leadership.
              </div>
            </div>
          </ModalBody>
          <ModalFooter css={{ justifyContent: "end !important" }}>
            <FlexRow justifyContent="flex-end" width="100%">
              <CustomSLButton
                aria-label="Cancel"
                role="button"
                css={{ padding: "0 10px 0 10px" }}
                secondary
                onClick={() => {
                  setSplitByMaterialModal(false);
                  setSplitByAckSelected(false);
                  setSelectedAction("");
                }}
              >
                Cancel
              </CustomSLButton>
              <CustomSLButton
                aria-label="Split By Material"
                disabled={!splitByAckSelected}
                role="button"
                primary
                onClick={() => {
                  setSplitByMaterialModal(false);
                  setSplitByAckSelected(false);
                  redirectToPrevPage();
                  setTimeout(() => {
                    renderSplitByMaterial(ticketData);
                  }, 0);
                  setSelectedAction("");
                }}
              >
                Split By Material
              </CustomSLButton>
            </FlexRow>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}

export const WorkTicketHistoryDetailedViewWTAMetadata = {
  name: "Detailed Work Ticket View",
  id: "Detailed_Work_Ticket_View",
  component: lazy(() => import("./WorkTicketHistoryDetailedViewWTA")),
  route: "/detailed_work_ticket_view",
};
